import { isEmpty } from "lodash-es";

import { STORE_FILTERS } from "../../storePicker.config";
import { useStorePickerContext } from "../../storePicker.context";
import { StorePickerFilter } from "../../types/storePickerFilter.enum";
import { StorePickerFilterComponent } from "./components/storePickerFilter/storePickerFilter.component";
import "./storePickerFilters.scss";

export const StorePickerFilters = () => {
    const { activeFilters, toggleFilter, config } = useStorePickerContext();

    const filters = STORE_FILTERS.filter(
        (storeFilter) =>
            config.displayStockLevel ||
            storeFilter !== StorePickerFilter.FILTER_EMPTY_STOCK
    );

    if (isEmpty(filters)) return null;

    return (
        <section className={"store-picker-filters"}>
            <ul className={"store-picker-filters__filters"}>
                {filters.map((storeFilter) => (
                    <StorePickerFilterComponent
                        key={storeFilter}
                        storeFeature={storeFilter}
                        active={activeFilters.includes(storeFilter)}
                        onToggle={toggleFilter}
                    />
                ))}
            </ul>
        </section>
    );
};
